import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Card,
  CardGroup,
  Form,
} from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

const OfficePassportList1 = () => {
  const [passports, setPassports] = useState([]);
  const [officeName, setOfficeName] = useState("");

  const [searchByStatus, setSearchByStatus] = useState("");

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchedPassports = async () => {
      try {
        const response = await axios.get(
          `/api/v1/passport/getPassportsByDeliveryOffice/${searchParams.get(
            "officeName"
          )}`
        );
        const filteredList = response.data.data.filter((passport) => {
          if (
            searchByStatus === "" ||
            passport.deliveryOfficePaymentStatus.includes(searchByStatus)
          ) {
            return passport;
          } else {
            return false;
          }
        });
        // setPassports(response.data.data);
        setPassports(filteredList);
      } catch (error) {
        console.log("error fetching passports:", error);
      }
    };
    fetchedPassports();
  }, [searchParams, searchByStatus]);

  // Pay Now button click handler

  const payNowHandler = async (id) => {
    try {
      await axios.patch(`/api/v1/passport/updatePaymentStatus/${id}`);

      // Update the status locally
      setPassports((prevPassports) => {
        return prevPassports.map((passport) => {
          if (passport._id === id) {
            return {
              ...passport,
              deliveryOfficePaymentStatus: "Paid",
            };
            // console.log(passport._id);
          }
          return passport;
        });
      });
    } catch (error) {
      console.log("error updating payment status:", error);
    }
  };

  return (
    <Container fluid className="my-4">
      <h2 className="mb-3 text-center fw-bold"> Passports List </h2>

      <Row>
        {/* Search Option */}
        <CardGroup className="mb-5 p-0">
          <Card>
            <Card.Header
              className="text-center text-black"
              as="h6"
              style={{ backgroundColor: "#74a2e3" }}
            >
              Search By Status
            </Card.Header>
            <Card.Body style={{ backgroundColor: "#74a2e3" }}>
              <Form>
                <Form.Control
                  as="select"
                  type="select"
                  name="searchByStatus"
                  value={searchByStatus}
                  onChange={(e) => setSearchByStatus(e.target.value)}
                  className="shadow-rounded"
                >
                  <option value="">Select Payment Status</option>
                  <option value="Due">Due</option>
                  <option value="Paid">Paid</option>
                </Form.Control>
              </Form>
            </Card.Body>
          </Card>
        </CardGroup>
        {/* Table */}
        <Card className="shadow" style={{ backgroundColor: "#74a2e3" }}>
          <Card.Header
            className="text-center text-black p-3"
            style={{ backgroundColor: "#74a2e3" }}
            as="h5"
          >
            Passports List for <strong>{searchParams.get("officeName")}</strong>
          </Card.Header>

          <Table
            rounded
            striped
            bordered
            hover
            responsive
            className="table-sm"
            style={{ maxHeight: "80vh" }}
          >
            <thead className="text-center">
              <tr>
                <th>Passport Name</th>
                <th>Passport Number</th>
                <th>Delivery Office</th>
                <th>Delivery Office Payment</th>
                <th>Status</th>
                <th>Pay Now</th>
              </tr>
            </thead>
            {passports.length === 0 ? (
              // <h6 className='text-center text-black'>No Passports Found Under That Delivery Office</h6>
              <tbody className="text-center">
                <tr>
                  <td colSpan="6">
                    <h6>No Passports Found!!</h6>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-center">
                {passports?.map((passport) => (
                  <tr key={passport._id}>
                    <td style={{ padding: "0px" }}>{passport.fullName}</td>
                    <td style={{ padding: "0px" }}>
                      {passport.passportNumber}
                    </td>
                    <td style={{ padding: "0px" }}>
                      {passport.deliveryOffice}
                    </td>
                    <td style={{ padding: "0px" }}>
                      {passport.deliveryOfficePayment}
                    </td>
                    <td style={{ padding: "0px" }}>
                      {passport.deliveryOfficePaymentStatus}
                    </td>
                    <td style={{ padding: "0px" }}>
                      {passport.deliveryOfficePaymentStatus === "Due" ? (
                        <Button
                          className="rounded"
                          variant="outline-success"
                          // onClick={payNowHandler.bind(this, passport._id)}
                          onClick={() => payNowHandler(passport._id)}
                        >
                          Pay Now
                        </Button>
                      ) : (
                        <Button
                          className="rounded"
                          variant="outline-success"
                          // onClick={() => payNowHandler(passport._id)}
                          disabled
                        >
                          Pay Now
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </Card>
      </Row>
    </Container>
  );
};

export default OfficePassportList1;
